import DashboardIcon from "../components/svg/dashboard";
import ProjectsIcon from "../components/svg/project";
import GoogleSheetIcon from "../components/svg/sheet";
import FileIcon from "../components/svg/file";
import Vendor from "../components/svg/vendor";

const constants = {
  API: {
    BASE_URL: "https://strategysoda.com",
    // BASE_URL: "http://43.205.51.154:3002",
  },
  COLOR: {
    PRIMARY: "#393188",
  },
  MESSAGES: {
    REQUIRED_FIELD: "This field is required",
    SUCCESS: "Success",
    DATA_IS_UPDATED_SUCCESSFULLY: "Data is updated successfully.",
    FAILED: "Failed",
    INVALID_CREDS: "Username/Password is invalid.",
    INTERNAL_SERVER_ERROR: "Internal server error.",
  },
  DATE_TIME_FORMATS: {
    DATE_FLATPICKER: "d-m-Y",
    DATE_FLATPICKER_CERT: "d/m/Y",
    DATE_UI: "DD-MM-YYYY",
    DATE_API: "YYYY-MM-DD",
    DATE_FULL_MONTH: "DD-MMM-YYYY",
    DATE_DAY: "day",
    DATE_DAYS: "days",
    FULL_MONTH: "MMM YYYY",
    TIME_12_HR: "h:mma",
    TIME_24_HR: "HH:mm",
    FULL_TIME: "HH:mm:ss",
  },
  BACK_BUTTON_SCREENS: [
    "/projects/add-project",
    "/projects/details/1",
    "/wrr/add",
    "/wrr/details/1",
    "/vpo/add",
    "/vpo/details/1",
    "/invoice/add",
    "/invoice/details/1",
    "/users/add",
    "/users/details/1",
  ],
  MENU_ITEMS: {
    PAGES: [
      { id: 1, label: "Home", link: "/home", icon: DashboardIcon },
      { id: 2, label: "Work", link: "/work", icon: ProjectsIcon },
      { id: 3, label: "Solution", link: "/services", icon: DashboardIcon },
      { id: 4, label: "Contact Us", link: "/contact-us", icon: FileIcon },
      { id: 6, label: "Careers", link: "/careers", icon: GoogleSheetIcon },
      { id: 7, label: "Footer", link: "/footer", icon: DashboardIcon },
    ],
    MASTER_PAGES: [
      { id: 1, label: "Blog", link: "/blog", icon: Vendor },
      { id: 2, label: "Case Studies", link: "/case-studies", icon: ProjectsIcon },
      { id: 3, label: "Documents", link: "/nda", icon: DashboardIcon },
      { id: 4, label: "Testimonials", link: "/testimonials", icon: DashboardIcon },
      { id: 5, label: "Queries", link: "/contactquery", icon: DashboardIcon },
      { id: 6, label: "Applicants", link: "/applications", icon: Vendor }
    ],
  },
  USERS: {
    ADMIN: { id: "ADMIN", pass: "ADMIN", role: "ADMIN" },
  },

  getS3File: (url) => {
    const S3_BUCKET_URL = "https://strategysoda.s3.ap-south-1.amazonaws.com";
    return `${S3_BUCKET_URL}/${url}`;
  },

  STORAGE_KEYS: {
    USER: "user",
  },
};

export default constants;
